module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/LTE#2-32caccf8c61be033a6190238c36a713c.svg";